module.exports = __webpack_public_path__ + "static/img/img_synergy@2x.f8141e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_synergy@2x.png
// module id = f+Hb
// module chunks = 0